app.controller('Teams', function ($scope, $http, $stateParams, $location, $mdToast, _$breadcrumbs,$rootScope) {
    $scope.action = false;
    $scope.data = {};

    $scope.delete = function (id) {
        var promise = $http.get('/administration/team/delete/' + id);
        promise.then(
                function (payload) {
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent(payload.data.msg)
                            .position('top right')
                            .hideDelay(3000)
                            );
                    if (payload.data.code) {
                        $scope.getList();
                    }
                });
    };

    $scope.showLoader = false;
    $scope.getList = function () {
        $scope.showLoader = true;
        $http.post('/administration/team/getlist')
                .success(function (list) {
                    $scope.showLoader = false;
                    $scope.teams = list;
                });
    };

    $scope.edit = function (team) {
        $location.path('/app/administration/team/edit/' + team.id);
    };

    $scope.check = function (form) {
        if (form.$valid) {
            $scope.save();
        } else {
            angular.forEach(form.$error, function (field) {
                angular.forEach(field, function (f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };

    $scope.save = function () {
        $http.post('/administration/team/save', $scope.team)
                .success(function (result) {
                    var msg = 'Typ konta został zapisany';
                    $mdToast.show(
                            $mdToast.simple()
                            .textContent(msg)
                            .position('top right')
                            .hideDelay(3000)
                            );
                    $location.path('/app/administration/team');
                });
    };

    $scope._init = function () {

        if (!_.isUndefined($stateParams.action)) {
            $scope.action = $stateParams.action;

            _$breadcrumbs.push($scope.action == 'new' ? 'Nowy typ konta odbiorcy' : 'Edycja typu konta odbiorcy');
            $scope.data.header = $scope.action == 'new' ? 'Nowy typ konta odbiorcy' : 'Edycja typu konta odbiorcy';

            if ($stateParams.action == 'edit') {
                if (_.isUndefined($stateParams.id)) {
                    $location.path('/app/administration/team');
                }
                $http.get('/administration/team/getteam/' + $stateParams.id)
                        .success(function (team) {
                            $scope.team = team;
                        });
            }
        }

        if (_.isUndefined($stateParams.action)) {
            $scope.getList();
        }
    };
    $scope._init();
});
